var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLanguageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.1,
    height: 18,
    viewBox: "0 0 17.1 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "language_Icon_1",
    "data-name": "language Icon 1",
    d: "M12.922,6.5h.9a.9.9,0,0,1,.9.9v.9a.9.9,0,1,0,1.8,0V7.4a2.7,2.7,0,0,0-2.7-2.7h-.9a.9.9,0,0,0,0,1.8Zm-3.6,8.1h-.9a.9.9,0,0,1-.9-.9v-.9a.9.9,0,0,0-1.8,0v.9a2.7,2.7,0,0,0,2.7,2.7h.9a.9.9,0,0,0,0-1.8Zm9.9-.9a.9.9,0,0,0,0-1.8h-2.7v-.45a.9.9,0,1,0-1.8,0v.45h-2.7a.9.9,0,0,0,0,1.8h4.666a6.055,6.055,0,0,1-1.1,2.274,6,6,0,0,1-.566-.884.9.9,0,0,0-1.6.821,7.81,7.81,0,0,0,.863,1.321,5.956,5.956,0,0,1-2.182.989.9.9,0,1,0,.384,1.759,7.771,7.771,0,0,0,3.1-1.459A7.851,7.851,0,0,0,18.7,19.979a.9.9,0,0,0,.388-1.758,6.052,6.052,0,0,1-2.2-.981,7.863,7.863,0,0,0,1.631-3.54ZM8.449,10.318A.9.9,0,1,0,10.2,9.881L8.613,3.555a2.053,2.053,0,0,0-3.983,0L3.049,9.881a.9.9,0,1,0,1.746.437L5.3,8.3H7.944ZM5.75,6.5l.627-2.508a.262.262,0,0,1,.49,0L7.494,6.5Z",
    transform: "translate(-3.021 -2)",
    fill: "#474b4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLanguageActive);
export default __webpack_public_path__ + "static/media/menu_language_active.e8d15118b4293f84d698d48d5fabe45c.svg";
export { ForwardRef as ReactComponent };